/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsHealthSummary } from './vcdsHealthSummary';
import { VcdsApplicationHealth } from './vcdsApplicationHealth';


export interface OperatorVcdsDeploymentApplicationAndInfraHealth { 
    application?: VcdsApplicationHealth;
    infrastructure?: { [key: string]: Array<VcdsHealthSummary>; };
}

